import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Helpers } from '../../../helpers';

declare let mApp: any;
@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements OnInit {
    ngbModalOptions: NgbModalOptions;

    constructor(private modalService: NgbModal) {
        this.ngbModalOptions = {
            size: 'lg'
        };
    }


    openModal(content) {
        this.modalService.open(content, this.ngbModalOptions).result.then((result) => {
            (<any>mApp).scrollTop();
            console.debug(`Closed with: ${result}`);
        }, (reason) => {
            (<any>mApp).scrollTop();
            console.debug('Dismissed');
        });
    }

    closeModal() {

    }


    ngOnInit() {

    }

}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/footer/footer.component.ts